import { Component, inject, Input, ChangeDetectionStrategy } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { MatIconButton } from '@angular/material/button'
import { MatToolbar } from '@angular/material/toolbar'
import { MatTooltip } from '@angular/material/tooltip'
import { ActivatedRoute, Router } from '@angular/router'
import { firstValueFrom, map } from 'rxjs'
import { UsersService } from '../users.service'
import { AsyncPipe, Location } from '@angular/common'
import { CdkCopyToClipboard } from '@angular/cdk/clipboard'
import { TranslatePipe } from '@ngx-translate/core'
import { LoggerService } from '../logger.service'
import { ToastService } from '../toast.service'

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [MatIcon, MatIconButton, MatToolbar, MatTooltip, AsyncPipe, CdkCopyToClipboard, TranslatePipe],
  templateUrl: './toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './toolbar.component.scss',
})
export class ToolbarComponent {
  @Input()
  title = ''

  @Input()
  backButtonLink: string[] | null = null

  @Input()
  meetingId: number | null = null

  @Input()
  showSupportButton = false

  router = inject(Router)
  route = inject(ActivatedRoute)
  usersService = inject(UsersService)
  location = inject(Location)
  currentUser$ = this.usersService.currentUser$
  logger = inject(LoggerService)
  toastService = inject(ToastService)
  meetingId$ = this.route.paramMap.pipe(map((params) => parseInt(params.get('id')!)))

  onIdCopied() {
    this.toastService.show('COMMON.COPIED_TO_CLIPBOARD')
  }

  navigateToSupportView() {
    firstValueFrom(this.meetingId$).then((meetingId) => {
      if (!Number.isNaN(meetingId)) {
        const url = this.router.serializeUrl(this.router.createUrlTree(['/app', 'support', 'meetings', meetingId]))
        window.open(url, '_blank')
      }
    })
  }

  goBack() {
    if (document.referrer === '') {
      this.logger.debug('No referrer found, redirecting to meetings')
      this.router.navigate(this.backButtonLink!)
      return
    }
    this.logger.debug(`Referer found. Going back to ${document.referrer}`)
    this.location.back()
  }
}
